import React, { useState, useRef, useEffect } from 'react';

export default function HashtagBadge({ tag, residente, reportCount = 0, onOpenDetail }) {
  const [showPopover, setShowPopover] = useState(false);
  const badgeRef = useRef(null);

  useEffect(() => {
    if (!showPopover) return;
    const handleClick = (e) => {
      if (badgeRef.current && !badgeRef.current.contains(e.target)) {
        setShowPopover(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showPopover]);

  if (!residente) {
    return (
      <span style={{
        background: 'linear-gradient(135deg, rgba(99,102,241,0.1), rgba(139,92,246,0.06))',
        color: 'var(--primary)', borderRadius: 20, fontWeight: 600,
        fontSize: '0.75rem', padding: '4px 14px',
        border: '1px solid rgba(99,102,241,0.2)'
      }}>#{tag}</span>
    );
  }

  return (
    <div ref={badgeRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={(e) => { e.stopPropagation(); setShowPopover(!showPopover); }}
        style={{
          background: 'linear-gradient(135deg, rgba(99,102,241,0.1), rgba(139,92,246,0.06))',
          color: 'var(--primary)', borderRadius: 20, fontWeight: 600,
          fontSize: '0.75rem', padding: '4px 14px', cursor: 'pointer',
          border: '1px solid rgba(99,102,241,0.2)', fontFamily: 'inherit',
          display: 'inline-flex', alignItems: 'center', gap: 5
        }}>
        #{tag}
        {reportCount > 0 && (
          <span style={{
            background: '#ef4444', color: '#fff', borderRadius: '50%',
            width: 18, height: 18, fontSize: '0.6rem', fontWeight: 700,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, marginLeft: 2
          }}>
            {reportCount > 9 ? '9+' : reportCount}
          </span>
        )}
      </button>

      {showPopover && (
        <div style={{
          position: 'absolute', bottom: 'calc(100% + 10px)', left: '50%',
          transform: 'translateX(-50%)', zIndex: 1000,
          background: '#fff', borderRadius: 16, padding: 18, minWidth: 240,
          boxShadow: '0 12px 40px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.05)',
          animation: 'slideInUp 0.2s ease'
        }}>
          {/* Arrow */}
          <div style={{
            position: 'absolute', bottom: -6, left: '50%', transform: 'translateX(-50%) rotate(45deg)',
            width: 12, height: 12, background: '#fff',
            boxShadow: '2px 2px 5px rgba(0,0,0,0.08)'
          }} />

          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <div style={{
              width: 42, height: 42, borderRadius: 12,
              background: 'linear-gradient(135deg, var(--primary), var(--primary-2))',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontSize: '1.1rem', fontWeight: 700, flexShrink: 0
            }}>
              {(residente.nombre_completo || '?')[0].toUpperCase()}
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--text)', lineHeight: 1.2 }}>
                {residente.nombre_completo}
              </div>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Residente</div>
            </div>
          </div>

          {/* Stats grid */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <InfoBadge icon="🏠" label="Apartamento" value={residente.apartamento} />
            <InfoBadge icon="🏗️" label="Piso" value={`P${residente.piso}`} />
            <InfoBadge icon="🪪" label="Cédula" value={residente.cedula} />
            <InfoBadge icon="📱" label="Celular" value={residente.celular} />
          </div>

          {/* Report count */}
          <div style={{
            marginTop: 12, padding: '8px 12px',
            background: 'linear-gradient(135deg, rgba(239,68,68,0.08), rgba(239,68,68,0.02))',
            borderRadius: 10, display: 'flex', alignItems: 'center', gap: 8
          }}>
            <span style={{
              background: '#ef4444', color: '#fff', borderRadius: '50%',
              width: 24, height: 24, fontSize: '0.7rem', fontWeight: 700,
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
            }}>
              {reportCount}
            </span>
            <span style={{ fontSize: '0.78rem', color: '#991b1b', fontWeight: 600 }}>
              {reportCount === 1 ? '1 reporte recibido' : `${reportCount} reportes recibidos`}
            </span>
          </div>

          {/* View full detail link */}
          {onOpenDetail && (
            <button
              onClick={(e) => { e.stopPropagation(); setShowPopover(false); onOpenDetail(tag); }}
              style={{
                marginTop: 10, width: '100%', background: 'rgba(99,102,241,0.06)',
                border: '1px solid rgba(99,102,241,0.15)', borderRadius: 10,
                padding: '8px 0', cursor: 'pointer', fontSize: '0.78rem',
                color: 'var(--primary)', fontWeight: 600, fontFamily: 'inherit'
              }}>
              📋 Ver historial completo →
            </button>
          )}
        </div>
      )}
    </div>
  );
}

function InfoBadge({ icon, label, value }) {
  return (
    <div style={{ padding: '8px 10px', background: 'rgba(241,245,249,0.6)', borderRadius: 8 }}>
      <div style={{ fontSize: '0.58rem', color: 'var(--text-light)', textTransform: 'uppercase', fontWeight: 600, marginBottom: 2 }}>
        {icon} {label}
      </div>
      <div style={{ fontWeight: 600, fontSize: '0.82rem', color: 'var(--text)' }}>
        {value || '-'}
      </div>
    </div>
  );
}